<template>
  <div class="app-container">
    <a
      href="https://apps.apple.com/gr/app/slm-crew/id1591603398"
      style="padding: 14px;"
    >
      <img
        alt="Get it on App Store"
        src="@/assets/images/play_store/app-store-badge.svg"
        width="240"
      />
    </a>
    <a
      href="https://play.google.com/store/apps/details?id=com.myjobnow.mjn_crew.prod&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    >
      <img
        alt="Get it on Google Play"
        src="@/assets/images/play_store/google-play-badge.png"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'DownloadMobileApp'
};
</script>

<style lang="scss" scoped>
.app-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  a {
    width: 240px;
  }
  img {
    width: 100%;
  }
}
</style>
